import {
  ArrowLeft2,
  ArrowRight2,
  Back,
  Edit,
  SearchNormal,
  Sort,
  Trash,
} from "iconsax-react";
import React, { useEffect, useState } from "react";
import { Link, useLoaderData, useNavigate } from "react-router-dom";
import { PaginationButton } from "../../../../../components/PaginationButton";
import instance from "../../../../../axios/instance";
import { getToken } from "../../../../../utils/token";

export const pendingConsultationsLoader = async ({ params }) => {
  const token = getToken();
  const data = await instance.get("/telemedicine/facility/consultation/pending", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return data;
};

export const PendingConsultationsPage = () => {
  const response = useLoaderData();
  const [consultationList, setConsultationList] = useState(
    [...response.data].map((_, index) => ({ ..._, index: index + 1 }))
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [sorted, setSorted] = useState("");
  const [filteredList, setFilteredList] = useState(
    consultationList.filter((_, index) => index + 1 <= 10)
  );
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();

    const query = searchQuery.toLowerCase();
    setFilteredList(() => {
      return consultationList
        .filter((consultation) => {
          const treatment = consultation.treatment;
          if (!treatment) return false;
          const id = `${consultation.id}`;
          const tId = `${treatment.id}`;
          const title = treatment.title?.toLowerCase().includes(query);
          const patientFirstname = consultation.patient.firstname
            .toLowerCase()
            .includes(query);
          const patientLastname = consultation.patient.lastname
            .toLowerCase()
            .includes(query);
          const doctorName = consultation.doctor_name
            .toLowerCase()
            .includes(query);

          return (
            id === query ||
            tId === query ||
            title ||
            patientFirstname ||
            patientLastname ||
            doctorName
          );
        })
        .filter((_, index) => index + 1 <= 10);
    });
  };

  useEffect(() => {
    setFilteredList(() =>
      consultationList.filter(
        (_, index) =>
          index + 1 > 10 * (pageIndex - 1) && index + 1 <= 10 * pageIndex
      )
    );
  }, [pageIndex]);

  const handleSort = (def) => {
    switch (def) {
      case "index": {
        setPageIndex(1);
        if (sorted !== "index") {
          setSorted("index");
        } else {
          setSorted("");
        }
        consultationList.reverse();
        setConsultationList(consultationList);
        setFilteredList((items) =>
          consultationList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "title": {
        setPageIndex(1);
        if (sorted === "title") {
          setSorted("");
          consultationList.sort((a, b) => a.index - b.index);
        } else {
          setSorted("title");
          consultationList.sort((a, b) => {
            if (a.title < b.title) return -1;
            if (a.title > b.title) return 1;
            return 0;
          });
        }
        setFilteredList((items) =>
          consultationList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "patient": {
        setPageIndex(1);
        if (sorted === "patient") {
          setSorted("");
          consultationList.sort((a, b) => a.index - b.index);
        } else {
          setSorted("patient");
          consultationList.sort((a, b) => {
            if (a.patient.lastname < b.patient.lastname) return -1;
            if (a.patient.lastname > b.patient.lastname) return 1;
            return 0;
          });
        }
        setFilteredList((items) =>
          consultationList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "doctor": {
        setPageIndex(1);
        if (sorted === "doctor") {
          setSorted("");
          consultationList.sort((a, b) => a.index - b.index);
        } else {
          setSorted("doctor");
          consultationList.sort((a, b) => {
            if (a.doctor_name < b.doctor_name) return -1;
            if (a.doctor_name > b.doctor_name) return 1;
            return 0;
          });
        }
        setFilteredList((items) =>
          consultationList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "amount": {
        setPageIndex(1);
        if (sorted === "amount") {
          setSorted("");
          consultationList.sort((a, b) => a.index - b.index);
        } else {
          setSorted("amount");
          consultationList.sort((a, b) => {
            if (+a.amount < +b.amount) return -1;
            if (+a.amount > +b.amount) return 1;
            return 0;
          });
        }
        setFilteredList((items) =>
          consultationList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "date": {
        setPageIndex(1);
        if (sorted === "date") {
          setSorted("");
          consultationList.sort((a, b) => a.index - b.index);
        } else {
          setSorted("date");
          consultationList.sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at)
          );
        }
        setFilteredList((items) =>
          consultationList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
    }
  };

  return (
    <>
      <div className="flex gap-x-2 mb-4 items-center">
        <Back
          size={30}
          onClick={() => navigate("/dashboard/telemedicine/consultations")}
          className="hover:text-primary cursor-pointer"
        />
        <div className="font-medium text-xl">
          Pending Consultations - {response.data.length}
        </div>
      </div>
      <div className="border bg-white rounded-md overflow-x-scroll scrollbar-hide mt-4">
        <div className="flex justify-between p-2 items-center">
          <form className="relative" onSubmit={handleSearch}>
            <input
              className="outline-none h-[40px] w-[300px] border rounded-md p-2 placeholder:font-normal placeholder:text-[14px] text-sm"
              placeholder="Search consultation"
              name="query"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button
              className="absolute h-[38px] rounded-md top-1/2 -translate-y-1/2 right-[1px] w-[30px] flex items-center justify-center bg-white cursor-pointer hover:text-primary duration-300"
              type="submit"
            >
              <SearchNormal size={15} />
            </button>
          </form>

          <div className="flex gap-2 items-center">
            <PaginationButton
              item={<ArrowLeft2 size={16} />}
              disabled={pageIndex <= 1}
              handleClick={() => setPageIndex(pageIndex - 1)}
            />
            <span className="font-light text-xs">Page {pageIndex}</span>
            <PaginationButton
              item={<ArrowRight2 size={16} />}
              disabled={pageIndex >= Math.ceil(consultationList.length / 10)}
              handleClick={() => setPageIndex((index) => index + 1)}
            />
          </div>
        </div>
        <div className="max-h-[70vh] overflow-y-scroll scrollbar-hide">
          <table className="w-full relative whitespace-nowrap">
            <thead>
              <tr className="uppercase h-14 font-bold bg-[#f1f1f1] text-gray-700 text-[12px]">
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("index")}
                >
                  #{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "index" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td className="px-6 py-4">ID</td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("title")}
                >
                  Title{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "title" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("patient")}
                >
                  Patient{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "patient" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("doctor")}
                >
                  Doctor{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "doctor" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("amount")}
                >
                  Amount{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "amount" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td className="px-6 py-4" onClick={() => handleSort("date")}>
                  Date Created{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "date" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
              </tr>
            </thead>

            <tbody>
              {filteredList.length < 1 ? (
                <tr>
                  <td className="px-6 py-4 font-normal" colSpan={6}>
                    You do not have any pending consultations
                  </td>
                </tr>
              ) : (
                filteredList.map((consultation, index) => (
                  <tr
                    key={consultation.id}
                    className="h-14 text-[14px] font-normal border-b"
                  >
                    <td className="px-6 py-4">{consultation.index}</td>
                    <td className="px-6 py-4">
                      <Link
                        to={`/dashboard/telemedicine/consultations/${consultation.id}`}
                        className="underline text-primary"
                      >
                        {consultation.id}
                      </Link>
                    </td>
                    <td className="px-6 py-4">
                      {consultation.treatment?.title || "N/A"}
                    </td>
                    <td className="px-6 py-4">
                      {`${consultation.patient.lastname} ${consultation.patient.firstname}`}
                    </td>
                    <td className="px-6 py-4 capitalize">
                      {consultation.doctor_name}
                    </td>
                    <td className="px-6 py-4 capitalize">
                      ${+consultation.amount.toLocaleString()}
                    </td>
                    <td className="px-6 py-4">
                      {new Date(consultation.created_at).toLocaleDateString()}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
